export default "__VITE_ASSET__d4d0cfb2__"